
import { tr } from '../translate'
import InfoCircle from '@/assets/icons/support_ticket/info-circle.svg?inline'

export default {
  components: { InfoCircle },
  props: {
    config: {
      type: Object,
      default: null,
    },
    category: {
      type: Object,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    ui() {
      return this.config?.ui
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
  },
}
